var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67709 5.50195L9.34611 11.3894M9.34611 11.3894L3.67709 18.502M9.34611 11.3894L10.6354 12.7283C11.4038 13.4455 12.5963 13.4455 13.3647 12.7283L14.72 11.3894M20.5 5.67904L14.72 11.3894M14.72 11.3894L20.5 18.3249M20.5 18.3249C20.8112 17.9723 21 17.5092 21 17.002V7.00195C21 5.89738 20.1046 5.00195 19 5.00195H5C3.89543 5.00195 3 5.89738 3 7.00195V17.002C3 17.5993 3.26188 18.1355 3.67709 18.502C4.02965 18.8132 4.49278 19.002 5 19.002H19C19.5973 19.002 20.1335 18.7401 20.5 18.3249Z",
    stroke: "#212227",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4ec3530e61de2f71e9a0b0edbbb8e54a.svg";
export { ForwardRef as ReactComponent };